// extracted by mini-css-extract-plugin
export default {"singleData":"style_singleData__uMvDN","row":"style_row__XwgIC","value":"style_value__fLWWQ"};